import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex h-[80vh] flex-col items-center justify-center">
      <h2
        style={{ fontFamily: "'Anton', sans-serif" }}
        className=" text-n-text-green text-5xl md:text-7xl lg:text-8xl"
      >
        404
      </h2>
      <p className="my-8 text-2xl text-n-green font-semibold">
        Página não encontrada.
      </p>
      <Link to="/">
        <Button>Voltar para a Home</Button>
      </Link>
    </div>
  );
}
